// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
     apiKey: "AIzaSyDUoUn2sDXvka1wMKTDuVQ2UW4ZgjHKfsk",
     authDomain: "carweb-b913e.firebaseapp.com",
     projectId: "carweb-b913e",
     storageBucket: "carweb-b913e.appspot.com",
     messagingSenderId: "984664394707",
     appId: "1:984664394707:web:79223fa211788ec5dbfd26"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;
